
import React from 'react';

const ValueStackMockup: React.FC = () => {
  return (
    <div className="relative w-full max-w-[500px] h-[400px] mx-auto mt-10">
      {/* El Producto Principal */}
      <div className="absolute left-0 bottom-10 w-[260px] z-10 drop-shadow-[20px_20px_30px_rgba(0,0,0,0.4)] transition-transform hover:scale-105 duration-300">
        <img 
          src="https://i.postimg.cc/FsJsqtSr/2.jpg" 
          alt="Ebook Principal" 
          className="w-full rounded-lg"
        />
      </div>

      {/* La Tablet (Checklist) */}
      <div className="absolute left-1/2 bottom-0 -translate-x-1/3 w-[240px] z-20 drop-shadow-[0_25px_40px_rgba(0,0,0,0.6)]">
        <div className="bg-slate-900 p-2 rounded-[1.5rem] border-[4px] border-slate-800 shadow-inner">
          <div className="bg-[#1a103c] rounded-xl overflow-hidden aspect-[3/4] flex flex-col items-center justify-center p-4 border border-white/5">
             <div className="w-10 h-10 bg-gold rounded-full mb-3 flex items-center justify-center">
                <span className="text-slate-900 font-black text-lg">✓</span>
             </div>
             <h4 className="text-white font-oswald text-center text-xs uppercase">Checklist de<br/>30 Minutos</h4>
             <div className="mt-4 w-full space-y-2 opacity-30">
                <div className="h-1 w-full bg-white rounded"></div>
                <div className="h-1 w-[80%] bg-white rounded"></div>
                <div className="h-1 w-[90%] bg-white rounded"></div>
             </div>
          </div>
        </div>
      </div>

      {/* El Smartphone */}
      <div className="absolute right-4 bottom-4 w-[110px] z-30 drop-shadow-[15px_15px_25px_rgba(0,0,0,0.5)] transform rotate-6">
        <div className="bg-slate-900 p-1.5 rounded-[1.2rem] border-[3px] border-slate-800">
          <div className="bg-gradient-to-b from-purple-600 to-indigo-900 rounded-[0.8rem] overflow-hidden aspect-[9/19] flex flex-col items-center justify-center p-2">
             <span className="text-[7px] font-black text-white uppercase tracking-tighter text-center">Guía Visual<br/>MOATs</span>
             <div className="mt-2 w-6 h-6 bg-white/20 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Insignia de Precio/Valor */}
      <div className="absolute top-0 right-0 bg-gold text-slate-900 w-24 h-24 rounded-full flex flex-col items-center justify-center z-40 shadow-2xl border-4 border-[#0f0a24] transform hover:rotate-12 transition-transform cursor-default">
         <span className="text-[10px] font-bold uppercase leading-none">Vale</span>
         <span className="text-2xl font-black font-oswald strike-through">$97</span>
      </div>
    </div>
  );
};

export default ValueStackMockup;